//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Metrics */
export const Metric = {
    /** Hosting Metric hard connects per second Guid */
    HostingHardConnectsPerSecond: "64D538D0-EE05-4646-91F5-EBE06460BDAB",
    /** Hosting Metric number of active connections Guid */
    HostingNumberOfActiveConnections: "68C54F46-A99E-4DD1-91CA-FC5941E6CFBE",
    /** Hosting Metric number of free connections Guid */
    HostingNumberOfFreeConnections: "8A1F73DD-4275-47C0-AF2A-6EABDA06E3C7",
    /** Hosting Metric soft connects per second Guid */
    HostingSoftConnectsPerSecond: "F90F9446-8754-4001-887C-1AB920968C6D",
};
